export const COMPANY_STATUS_OPTIONS = [
  "New",
  "Contacted",
  "Discovery",
  "Proposal",
  "Active Client",
  "Do Not Contact",
];

export const ACTIVE_CLIENT_COMPANY_STATUS = "Active Client";

const COMPANY_STATUS_LABEL_BY_KEY = new Map([
  ["new", "New"],
  ["contacted", "Contacted"],
  ["discovery", "Discovery"],
  ["proposal", "Proposal"],
  ["active client", "Active Client"],
  ["client", "Active Client"],
  ["active", "Active Client"],
  ["do not contact", "Do Not Contact"],
  ["prospect", "New"],
  ["no stage", "New"],
  ["inactive", "Do Not Contact"],
  ["lost", "Do Not Contact"],
]);

export function normalizeCompanyStatusLabel(
  value,
  { fallback = "New", preserveUnknown = false } = {}
) {
  const raw = String(value ?? "").trim();
  if (!raw) return fallback;

  const normalized = COMPANY_STATUS_LABEL_BY_KEY.get(raw.toLowerCase());
  if (normalized) return normalized;

  return preserveUnknown ? raw : fallback;
}

export function isActiveClientCompanyStatus(value) {
  return (
    normalizeCompanyStatusLabel(value, {
      fallback: "",
      preserveUnknown: true,
    }) === ACTIVE_CLIENT_COMPANY_STATUS
  );
}
